import React from "react";
import "./Strategies.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faBullseye,
  faLayerGroup,
  faPenRuler,
  faGear,
  faArrowTrendUp,
} from "@fortawesome/free-solid-svg-icons";

const strategyItems = [
  {
    icon: faChartLine,
    title: "Market and Funnel Analysis",
    description:
      "We review demand, audience behavior, and current funnel performance before defining execution.",
  },
  {
    icon: faBullseye,
    title: "Offer Positioning and Messaging",
    description:
      "We sharpen value communication so prospects quickly understand why to choose your solution.",
  },
  {
    icon: faLayerGroup,
    title: "Execution Roadmap",
    description:
      "We create a phased roadmap connecting acquisition, conversion, and retention goals.",
  },
  {
    icon: faPenRuler,
    title: "Page and Content Strategy",
    description:
      "Page hierarchy, copy, and creative direction are designed to reduce friction and improve action rates.",
  },
  {
    icon: faGear,
    title: "Tracking and Automation",
    description:
      "We set up forms, attribution, and follow-up systems to capture and route leads consistently.",
  },
  {
    icon: faArrowTrendUp,
    title: "Testing and Optimization",
    description:
      "We run ongoing experiments and refinements so performance compounds over time.",
  },
];

const Strategies = () => {
  return (
    <section className="sg-about" aria-label="Our strategy">
      <div className="sg-about-wrap">
        <header className="sg-about-head">
          <span className="sg-about-kicker">Our strategy</span>
          <h2>Structured strategy focused on business outcomes</h2>
          <p>
            We align every action with measurable objectives so growth is
            repeatable, not dependent on one-time tactics.
          </p>
        </header>

        <div className="sg-about-grid">
          {strategyItems.map((item) => (
            <article className="sg-about-card" key={item.title}>
              <div className="sg-about-icon">
                <FontAwesomeIcon icon={item.icon} />
              </div>

              <div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Strategies;
